import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnInit,
    signal,
    ViewEncapsulation,
} from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { OptBean } from "../s25-opt/s25.opt.component";
import { S25ObjectDetailsService } from "./s25.object.details.service";
import { Bind } from "../../decorators/bind.decorator";
import { Item } from "../../pojo/Item";
import { Contact } from "../../pojo/Contact";
import { S25LoadingApi } from "../s25-loading/loading.api";
import { Panel } from "../s25-panel/s25.panels.component";

@TypeManagerDecorator("s25-ng-object-details")
@Component({
    selector: "s25-ng-object-details",
    template: `
        @if (optBean()) {
            <s25-ng-opt [modelBean]="optBean()"></s25-ng-opt>
        }
        <s25-loading-inline [model]="{}"></s25-loading-inline>
        @if (init()) {
            @let warningMessage = data?.warningMessage;
            @if (warningMessage) {
                <div #warningMsgEl class="cn-alert cn-alert--warning">
                    {{ warningMessage.message }}
                    @if (warningMessage.link) {
                        View the&nbsp;<a [href]="warningMessage.link">help page</a>&nbsp;for more information.
                    }
                    <button class="c-textButton" (click)="warningMsgEl.classList.toggle('ngHidden')">
                        <s25-ng-icon [type]="'close'"></s25-ng-icon>
                    </button>
                </div>
            }
            <div class="details-wrapper">
                <s25-ng-panels [panels]="panels"> </s25-ng-panels>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25ObjectDetailsComponent implements OnInit {
    @Input({ required: true }) itemId: number;
    @Input({ required: true }) itemTypeId: Item.Id;

    init = signal(false);
    optBean = signal<OptBean>(null);
    data: Partial<ObjDetailsData>;
    panels: Panel[] = [];

    constructor(private el: ElementRef) {}

    async ngOnInit() {
        const optBean = await S25ObjectDetailsService.getOptBean(this.itemId, this.itemTypeId);
        this.optBean.set({
            ...optBean,
            autoInit: false,
            refreshF: this.refresh,
        });
        await this.initObjectDetails();
    }

    @Bind
    refresh() {
        this.init.set(false);
        S25ObjectDetailsService.invalidateCache(this.itemTypeId);
        return this.initObjectDetails();
    }

    async initObjectDetails() {
        S25LoadingApi.init(this.el.nativeElement);
        this.data = await S25ObjectDetailsService.getObjDetailsData(this.itemId, this.itemTypeId);
        this.panels = this.data.panels;
        S25LoadingApi.destroy(this.el.nativeElement);
        return this.init.set(true);
    }
}

export type ObjDetailsData = {
    warningMessage: { message: string; link: string };
    general: Contact.DetailData["general"];
    userAccount: Contact.DetailData["userAccount"];
    panels: Panel[];
};
